import Vue from 'vue'
import Router from 'vue-router'
import Panel from '@/components/panel'
import store from '@/store'

//Giriş
import GirisRouter from '@/Module/giris/_route'
import Giris from '@/Module/giris/index'
import Kayit from '@/Module/giris/kayit'
import Parola from '@/Module/giris/parola'

//Ürün
import Urun from '@/Module/urun/_route'
import UrunIndex from '@/Module/urun/index'
//Cari
import Cari from '@/Module/cari/_route'
import CariIndex from '@/Module/cari/index'

//Kasa
import Kasa from '@/Module/kasa/_route'
import KasaIndex from '@/Module/kasa/index'

//Kategori
import Kategori from '@/Module/kategori/_route'
import KategoriIndex from '@/Module/kategori/index'

//Gider
import GiderRouter from '@/Module/gider/_route'
import GiderIndex from '@/Module/gider/index'

import GiderOdemeRoute from '@/Module/gider/odeme'
import GiderOdemeListe from '@/Module/gider/odeme/liste'
import GiderOdemeDetay from '@/Module/gider/odeme/detay'

import GiderFaturaRoute from '@/Module/gider/fatura'
import GiderFaturaListe from '@/Module/gider/fatura/liste'
import GiderFaturaDetay from '@/Module/gider/fatura/detay'
import GiderFaturaYeni from '@/Module/gider/fatura/yeni'
import GiderFaturaDuzenle from '@/Module/gider/fatura/duzenle'

//Gelir
import GelirRouter from '@/Module/gelir/_route'
import GelirIndex from '@/Module/gelir/index'

import GelirOdemeRoute from '@/Module/gelir/odeme'
import GelirOdemeListe from '@/Module/gelir/odeme/liste'
import GelirOdemeDetay from '@/Module/gelir/odeme/detay'

import GelirFaturaRoute from '@/Module/gelir/fatura'
import GelirFaturaListe from '@/Module/gelir/fatura/liste'
import GelirFaturaDetay from '@/Module/gelir/fatura/detay'
import GelirFaturaYeni from '@/Module/gelir/fatura/yeni'
import GelirFaturaDuzenle from '@/Module/gelir/fatura/duzenle'

//Teklif
import TeklifRouter from '@/Module/teklif/_route'
import TeklifIndex from '@/Module/teklif/index'

import TeklifFaturaRoute from '@/Module/teklif/fatura'
import TeklifFaturaListe from '@/Module/teklif/fatura/liste'
import TeklifFaturaDetay from '@/Module/teklif/fatura/detay'
import TeklifFaturaYeni from '@/Module/teklif/fatura/yeni'

//404
import Hata from '@/Module/404'
import Ayar from '@/Module/ayar'
import Stok from '@/Module/stok/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/panel',
      component: Panel,
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },
    {
      path: '/',
      component: Panel,
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }


    },
    {
      path: "/cari",
      component: Cari,
      children: [
        {path: "", component: CariIndex},
      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }


    },
    {
      path: "/giris",
      component: GirisRouter,
      children: [
        {path: "", component: Giris},
        {path: "kayit", component: Kayit},
        {path: "parola", component: Parola},
      ],
      beforeEnter(to, from, next) {
        if (store.state.access_token) {
          next("/panel");
        } else {
          next();
        }
      }

    },
    {
      path: "/kategori",
      component: Kategori,
      children: [
        {path: "", component: KategoriIndex},
      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },
    {
      path: "/kasa",
      component: Kasa,
      children: [
        {path: "", component: KasaIndex},
      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },

    {
      path: "/urun",
      component: Urun,
      children: [
        {path: "", component: UrunIndex},
      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },


    {
      path: "/teklif",
      component: TeklifRouter,
      children: [
        {path: "", component: TeklifIndex},
        {
          path: "fatura", component: TeklifFaturaRoute,
          children: [
            {path: "", component: TeklifFaturaListe},
            {path: "yeni", component: TeklifFaturaYeni},
            {path: "detay/:Fatura_id", component: TeklifFaturaDetay, props: true},
          ]
        },

      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },


    {
      path: "/gider",
      component: GiderRouter,
      children: [
        {path: "", component: GiderIndex},
        {
          path: "odeme", component: GiderOdemeRoute,
          children: [
            {path: "", component: GiderOdemeListe},
            {path: ":Odeme_id", component: GiderOdemeDetay, props: true},
          ]
        },
        {
          path: "fatura", component: GiderFaturaRoute,
          children: [
            {path: "", component: GiderFaturaListe},
            {path: "yeni", component: GiderFaturaYeni},
            {path: "duzenle/:Fatura_id", component: GiderFaturaDuzenle, props: true},
            {path: "detay/:Fatura_id", component: GiderFaturaDetay, props: true},
          ]
        },

      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },


    {
      path: "/gelir",
      component: GelirRouter,
      children: [
        {path: "", component: GelirIndex},
        {
          path: "odeme", component: GelirOdemeRoute,
          children: [
            {path: "", component: GelirOdemeListe},
            {path: ":Odeme_id", component: GelirOdemeDetay, props: true},
          ]
        },
        {
          path: "fatura", component: GelirFaturaRoute,
          children: [
            {path: "", component: GelirFaturaListe},
            {path: "yeni", component: GelirFaturaYeni},
            {path: "duzenle/:Fatura_id", component: GelirFaturaDuzenle, props: true},
            {path: "detay/:Fatura_id", component: GelirFaturaDetay, props: true},
          ]
        },

      ],
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },


    {
      path: '/ayarlar',
      component: Ayar,
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },

    {
      path: '/stok',
      component: Stok,
      beforeEnter(to, from, next) {
        if (store.getters.isOturum) {
          next();
        } else {
          next("/giris");
        }
      }
    },


    {path: "*", component: Hata}


  ],
  mode: "history",
  linkExactActiveClass: "active"
})



// WEBPACK FOOTER //
// ./src/router/index.js